// import Map from "../components/map.js";
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';

import { MapContainer, TileLayer, useMapEvents } from 'react-leaflet'
import MapSpecs from "../mapspec/mapspecs.js";

function DataLayer({ visible, initialZoom, initialCenter, onUpdate, mapType }) {
    const [zoomLevel, setZoomLevel] = useState(initialZoom);
    const map = useMapEvents({
        zoomend(e) {
            setZoomLevel(map.getZoom());
        },
    });

    const opacity = zoomLevel <= 14 ? 1
        : Math.max(0, Math.min(1, (22 - zoomLevel) / 8));

    const url = `https://storage.googleapis.com/wherecaniseefuji/${mapType}/{z}_{x}_{y}.png`;
    // const url = "/tiles/" + mapType + "/{z}_{x}_{y}.png";
    if (!visible) {
        return <></>;
    }
    return <TileLayer
        url={url}
        opacity={opacity}
    />;
}
const Map = ({ mapType }) => {
    const initialCenter = [35.6620, 139.7038];
    const initialZoom = 12;
    return (
        <MapContainer
            center={initialCenter}
            zoom={initialZoom}
            // zoomSnap={0.1}
            scrollWheelZoom={true}
            style={{ height: "100%", width: "100%" }}
        >
            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                opacity={0.3}
            />
            {
                Object.entries(MapSpecs).map(([id, mapSpec]) =>
                    <DataLayer
                        key={`map_${id}`}
                        visible={id === mapType}
                        mapType={id}
                        initialZoom={initialZoom}
                        initialCenter={initialCenter}
                    />)
            }
        </MapContainer >
    )
}
export default Map;
